import React, {Component} from 'react';
import Graph from './graph-components/graph';
import './App.css';

class App extends Component {
    render() {
        return (
            <Graph data={this.props.data} />
        )
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js